export default __webpack_public_path__ + "static/media/ppt.4248858a.svg";